export function CurrencyFormat(num) {
  let isnum = /^-?[0-9]\d*(\.\d+)?$/.test(num);
  if (isnum) {
    return (
      "Rp. " +
      parseInt(num)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    );
  } else {
    return "Rp. " + num;
  }
}
